import React, { Component } from 'react'
import {
    Card,
    Cascader,
    Form,
    Button,
    Input,
    Tabs,
    Space,
    Modal,
    Divider,
    Radio,
    message,
    InputNumber,
} from "antd";
import {
    EditableProTable
} from '@ant-design/pro-components';
import { NoticeBar } from 'antd-mobile'
import { hall, user } from "../../../../service";
import { useNavigate } from 'react-router-dom';
import { withParams } from '../../../../utils/util'
import { connect } from 'react-redux';
import provinces from "china-division/dist/provinces";
import cities from "china-division/dist/cities";
import areas from "china-division/dist/areas";
import "./index.scss";

class ServiceManage extends Component {
    form = React.createRef()
    form2 = React.createRef()
    state = {
        type: 1,                // 类型 1 服务 2需求
        options: [],
        record: {},
        record2: {},
        openModal: false,
        keys: [],
        keys2: [],
        dataSource: [],
        editableKeys: [],
        dataSource2: [],
        editableKeys2: [],
        columns: [
            {
                title: '设备类型',
                dataIndex: 'classify',
                formItemProps: (form, { rowIndex }) => {
                    return {
                        rules: [{ required: true, message: '此项为必填项' }]
                    };
                },
            },
            {
                title: '设备数量',
                dataIndex: 'num',
                width: 350,
                formItemProps: (form, { rowIndex }) => {
                    return {
                        rules: [{ required: true, message: '此项为必填项' }]
                    };
                },
            },
            {
                title: '操作',
                valueType: 'option',
                width: 150,
                render: (text, record, _, action) => [
                    <a
                        key="editable"
                        onClick={() => {
                            action?.startEditable?.(record.id);
                        }}
                    >
                        编辑
                    </a>,
                    <a
                        key="delete"
                        onClick={() => {
                            this.setState({ dataSource: this.state.dataSource.filter((item) => item.id !== record.id) });
                        }}
                    >
                        删除
                    </a>,
                ],
            },
        ],
        columns2: [
            {
                title: '地址',
                dataIndex: 'address',
                width: 350,
                formItemProps: (form, { rowIndex }) => {
                    return {
                        rules: [{ required: true, message: '此项为必填项' }]
                    };
                },
            },
            {
                title: '面积（亩）',
                dataIndex: 'area',
                formItemProps: (form, { rowIndex }) => {
                    return {
                        rules: [{ required: true, message: '此项为必填项' }]
                    };
                },
            },
            {
                title: '操作',
                valueType: 'option',
                width: 150,
                render: (text, record, _, action) => [
                    <a
                        key="editable"
                        onClick={() => {
                            action?.startEditable?.(record.id);
                        }}
                    >
                        编辑
                    </a>,
                    <a
                        key="delete"
                        onClick={() => {
                            this.setState({ dataSource2: this.state.dataSource2.filter((item) => item.id !== record.id) });
                        }}
                    >
                        删除
                    </a>,
                ],
            },
        ]
    }

    // 首次加载数据
    componentDidMount() {
        this.getClassify()
        this.fetch()
    }


    fetch = async () => {
        const { type } = this.state
        // 查询已选标签
        const res = await user.apiManage.search(type)

        try {

            if (type === 1) {
                const { data } = await user.apiDevs.search()
                this.setState({
                    dataSource: data,
                    keys: res.data && res.data.classify,
                    record: res.data || {},
                }, () => this.form.current.setFieldsValue({
                    classify: res.data?.classify,
                    address: res.data?.address,
                }))
            } else if (type === 2) {
                const { data } = await user.apiLands.search()
                this.setState({
                    dataSource2: data,
                    keys2: res.data && res.data.classify,
                    record2: res.data || {}
                }, () => this.form2.current.setFieldsValue({
                    classify: this.state.keys2,
                }))

            }
        } catch (error) {
            console.log(error);
        }

    }

    getClassify = async () => {
        const { data } = await hall.apiClassify.getClassifyTree()
        this.setState({ options: data })
    }

    onFinish = async () => {
        const { record, dataSource, type } = this.state
        if (dataSource.length === 0) {
            message.warning('请填写与服务内容相关联的设备！')
        }
        const values = await this.form.current.validateFields()
        await user.apiDevs.post(dataSource.map(({ num, classify }) => ({ num, classify })))
        if (record && record.id) {
            await user.apiManage.put({ ...values, type: type, id: record.id })
            message.success('提交成功！')
        } else {
            await user.apiManage.post({ ...values, type: type, })
            message.success('提交成功！')
        }
    }

    onFinish2 = async () => {
        const { record2, dataSource2, type } = this.state
        const values = await this.form2.current.validateFields()
        await user.apiLands.post(dataSource2.map(({ area, address }) => ({ area, address })))
        if (record2 && record2.id) {
            await user.apiManage.put({ ...values, type: type, id: record2.id })
            message.success('提交成功！')
        } else {
            await user.apiManage.post({ ...values, type: type, })
            message.success('提交成功！')
        }
    }


    onTabsChange = (value) => {
        this.setState({ type: Number(value), keys: [] }, () => this.fetch())
    }

    render() {
        const { options, record, record2, openModal, columns, dataSource, editableKeys, columns2, dataSource2, editableKeys2 } = this.state
            , { onFinish, onFinish2, onTabsChange } = this
            , optionsAddress = provinces.map((province) => ({ ...province, children: cities.filter(citie => province.code === citie.provinceCode).map(citie => ({ ...citie, children: areas.filter(area => area.cityCode === citie.code) })) }))

        return (
            <Card
                title="资质管理"
                className='qualification'
            >
                <Tabs
                    defaultActiveKey="1"
                    onChange={onTabsChange}
                    items={[
                        {
                            key: '1',
                            label: '服务管理',
                            children: (
                                <div>
                                    <div style={{ marginBottom: 10 }}>
                                        {
                                            record.state === 0 ? (<NoticeBar content='待审核' color='alert' closeable />) :
                                                record.state === 1 ? (<NoticeBar content='审核通过' color='info' closeable />) :
                                                    record.state === 2 ? (<NoticeBar content='审核不通过' color='error' extra={
                                                        <Space style={{ '--gap': '12px' }}>
                                                            <Button
                                                                type='link'
                                                                style={{ color: '#fff' }}
                                                                onClick={() => this.setState({ openModal: true })}
                                                            >查看详情</Button>
                                                        </Space>
                                                    } />) : null
                                        }
                                    </div>

                                    <Form
                                        ref={this.form}
                                        name="hd.unbind.form"
                                        onFinish={onFinish}
                                    >
                                        <Form.Item
                                            name='classify'
                                            label='服务内容'
                                            labelCol={{ span: 3 }}
                                            rules={[{ required: true, message: '请选择' }]}
                                        >
                                            <Cascader
                                                size='large'
                                                maxTagCount={100}
                                                fieldNames={{ label: 'name', value: 'id' }}
                                                options={options}
                                                multiple
                                                showCheckedStrategy={Cascader.SHOW_CHILD}
                                            />
                                        </Form.Item>

                                        <Form.Item
                                            name='address'
                                            label='服务区域'
                                            labelCol={{ span: 3 }}
                                        >
                                            <Input.TextArea />
                                        </Form.Item>

                                        <Divider orientation="left" plain>
                                            请填写设备
                                        </Divider>

                                        <EditableProTable
                                            rowKey="id"
                                            headerTitle=""
                                            maxLength={100}
                                            recordCreatorProps={
                                                {
                                                    position: 'bottom',
                                                    record: () => ({ id: (Math.random() * 1000000).toFixed(0) }),
                                                }
                                            }
                                            loading={false}
                                            columns={columns}
                                            request={async () => ({
                                                data: [],
                                                total: 3,
                                                success: true,
                                            })}
                                            value={dataSource}
                                            onChange={(value) => this.setState({ dataSource: value })}
                                            editable={{
                                                type: 'multiple',
                                                editableKeys,
                                                onSave: async (rowKey, data, row) => {
                                                    console.log(rowKey, data, row);
                                                },
                                                onChange: (value) => this.setState({ editableKeys: value }),
                                            }}
                                        />

                                        <Form.Item
                                            style={{ width: 100, margin: 'auto' }}
                                        >
                                            <Button
                                                type='primary'
                                                block
                                                size='large'
                                                style={{ marginTop: '20px' }}
                                                htmlType="submit"
                                            >提交</Button>
                                        </Form.Item>

                                    </Form>

                                </div>
                            ),
                        },
                        {
                            key: '2',
                            label: '需求管理',
                            children: (
                                <div>
                                    <div style={{ marginBottom: 10 }}>
                                        {
                                            record2.state === 0 ? (<NoticeBar content='待审核' color='alert' closeable />) :
                                                record2.state === 1 ? (<NoticeBar content='审核通过' color='info' closeable />) :
                                                    record2.state === 2 ? (<NoticeBar content='审核不通过' color='error' extra={
                                                        <Space style={{ '--gap': '12px' }}>
                                                            <Button
                                                                type='link'
                                                                style={{ color: '#fff' }}
                                                                onClick={() => this.setState({ openModal: true })}
                                                            >查看详情</Button>
                                                        </Space>
                                                    } />) : null
                                        }
                                    </div>
                                    <Form
                                        ref={this.form2}
                                        name="hd.unbind2.form"
                                        onFinish={onFinish2}
                                    >
                                        <Form.Item
                                            name='classify'
                                            label='需求内容'
                                            labelCol={{ span: 3 }}
                                            rules={[{ required: true, message: '请选择' }]}
                                        >
                                            <Cascader
                                                size='large'
                                                maxTagCount={100}
                                                fieldNames={{ label: 'name', value: 'id' }}
                                                options={options}
                                                multiple
                                                showCheckedStrategy={Cascader.SHOW_CHILD}
                                            />
                                        </Form.Item>

                                        <Divider orientation="left" plain>
                                            请填写需求区域
                                        </Divider>

                                        <EditableProTable
                                            rowKey="id"
                                            headerTitle=""
                                            maxLength={100}
                                            recordCreatorProps={
                                                {
                                                    position: 'bottom',
                                                    record: () => ({ id: (Math.random() * 1000000).toFixed(0) }),
                                                }
                                            }
                                            loading={false}
                                            columns={columns2}
                                            request={async () => ({
                                                data: [],
                                                total: 3,
                                                success: true,
                                            })}
                                            value={dataSource2}
                                            onChange={(value) => this.setState({ dataSource2: value })}
                                            editable={{
                                                type: 'multiple',
                                                editableKeys: editableKeys2,
                                                onSave: async (rowKey, data, row) => {
                                                    console.log(rowKey, data, row);
                                                },
                                                onChange: (value) => this.setState({ editableKeys2: value }),
                                            }}
                                        />

                                        <Form.Item
                                            style={{ width: 100, margin: 'auto' }}
                                        >
                                            <Button
                                                type='primary'
                                                block
                                                size='large'
                                                style={{ marginTop: '20px' }}
                                                htmlType="submit"
                                            >提交</Button>
                                        </Form.Item>

                                    </Form>

                                </div>
                            ),
                        },
                    ]} />

                <Modal
                    title="驳回详情"
                    open={openModal}
                    footer={null}
                    onCancel={() => this.setState({ openModal: false })}
                >
                    <div style={{ minHeight: 100, textIndent: 40 }}>{
                        this.state.type === 1 ? record.remark : record2.remark
                    }</div>
                </Modal>
            </Card>


        )
    }

}

const mapStateToProps = (state) => ({
    serverUrl: state.siteInfo.serverUrl
})
const ConnectedView = connect(mapStateToProps)(ServiceManage);

export default withParams(ConnectedView, () => { }, () => { }, useNavigate)
